import logo from './logo.svg';
import './App.css';
import Navbar from "./component/Navbar"
import About from './component/About';
import Contact from './component/Contact';
import Allroutes from './route/Allroutes';
import { Heading, Text, useColorModeValue } from '@chakra-ui/react';
function App() {
  return (
    <div className="App" 
    >
      
     <Navbar/> 
     <Allroutes/>
     <Text mb={30} fontWeight={"bold"}>For this UI I am inspired by<a href='https://github.com/chhavi48' target={"_blank"}> Chhavi </a> who is one of my seniors.</Text>
   
   
    </div>
  );
}

export default App;
